import { IconButton } from '@ds';
import { MdOutlineCancel, MdOutlineWarning } from 'react-icons/md';
import { QuoteRejectReason } from '@/api/apis/case';
import { caseQuoteRejectedReasonNames } from '@/constants/case/case.constants';

type QuoteRejectedInfoProps = {
  reason: QuoteRejectReason;
  onClose: () => void;
};

const QuoteRejectedInfo = ({ reason, onClose }: QuoteRejectedInfoProps) => (
  <div className="flex bg-danger-70 rounded-xl px-3 py-1 mt-5 items-center gap-2">
    <MdOutlineWarning size={30} className="text-danger-40" />
    <div className="flex flex-col w-full">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-1">
          <span className="underline text-danger-5 text-m-r">Quote Rejected: </span>
          <span className="text-danger-5 text-m-r">{caseQuoteRejectedReasonNames[reason]}</span>
        </div>
        <IconButton
          className="my-1 text-danger-10 border-danger-10 border-0 bg-transparent"
          size="xs"
          variant="outline"
          startContent={<MdOutlineCancel className="h-[20px]! w-[20px]!" />}
          onPress={onClose}
        />
      </div>
    </div>
  </div>
);

export default QuoteRejectedInfo;
